import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

import { UserPickerModule } from '../user-picker/user-picker.module';
import { UsersPickerComponent } from './users-picker.component';

@NgModule({
    imports: [
        UserPickerModule,
        CommonModule,
        MatChipsModule,
        MatIconModule,
        ReactiveFormsModule
    ],
    declarations: [
        UsersPickerComponent
    ],
    exports: [
        UsersPickerComponent
    ]
})
export class UsersPickerModule {
}
